import React, { useCallback } from "react";

import SignIn from "./signIn";
import Register from "./register";

const AuthForm = (props) => {
  const authFormClose = useCallback(() => {
    props.setAuthFormTrigger(false);
    props.setLogInTrigger(false);
    props.setRegisterTrigger(false);
  }, [props]);

  return (
    <div className="absForm">
      <div className="absForm__container">
        <button className="btn--close" onClick={() => authFormClose()}>
          Fermer
        </button>

        {props.logInTrigger && (
          <SignIn
            setRegisterTrigger={props.setRegisterTrigger}
            setLogInTrigger={props.setLogInTrigger}
          />
        )}
        {props.registerTrigger && (
          <Register
            setRegisterTrigger={props.setRegisterTrigger}
            setLogInTrigger={props.setLogInTrigger}
          />
        )}
      </div>
    </div>
  );
};

export default AuthForm;
